import { Component, OnInit, EventEmitter, ViewChild, QueryList, ViewChildren, Inject, HostListener } from '@angular/core';
import { ToastService, UploadFile, UploadInput, UploadOutput } from 'ng-uikit-pro-standard';
import { humanizeBytes } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { MaquinasMaestroModalAddEditComponent } from './modal-add-edit/modal-add-edit.component';
import { MaquinasMaestroModalAsignarComponent } from './modal-asignar/modal-asignar.component';
// import { MaquinasMaestroModalCargaMasivaComponent } from './modal-carga-masiva/modal-carga-masiva.component';
import { MaquinasMaestroModalDarDeBajaComponent } from './modal-dar-de-baja/modal-dar-de-baja.component';
import { MaquinasMaestroModalVerMovimientoComponent } from './modal-ver-movimiento/modal-ver-movimiento.component';
import { debounceTime, filter } from 'rxjs/operators';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { ModalSeleccionarClienteComponent } from '../../shared/modal-seleccionar-cliente/modal-seleccionar-cliente.component';
import { VendedorService } from 'src/app/services/vendedor.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { MaquinaService } from 'src/app/services/maquina.service';
import { EstadoMaquinaService } from 'src/app/services/estado-maquina.service';
import { ClienteProveedorService } from 'src/app/services/cliente-proveedor.service';
import { MaquinaFamiliaService } from 'src/app/services/maquina-familia.service';
import * as _ from 'lodash';
import { FileDownloadService } from 'src/app/shared/services/file-download.service';
import { ModalConfirmComponent } from 'src/app/shared/components/modal-confirm/modal-confirm.component';
import { Subscription } from 'apollo-client/util/Observable';
import { DOCUMENT } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { RubroService } from 'src/app/services/rubro.service';
import { ModalCargaMasivaComponent } from '../../shared/modal-carga-masiva/modal-carga-masiva.component';
import { RolOperacionService } from 'src/app/services/rol-operacion.service';

@Component({
  selector: 'app-maquinas-maestro',
  templateUrl: './maquinas-maestro.component.html',
  styleUrls: ['./maquinas-maestro.component.scss'],
  providers: [SecurityService],
})
export class MaquinasMaestroComponent implements OnInit {
  // Modales
  @ViewChild(ModalSeleccionarClienteComponent, { static: true }) modalSeleccionarCliente: ModalSeleccionarClienteComponent;
  @ViewChild(ModalCargaMasivaComponent, { static: true }) modalCargaMasiva: ModalCargaMasivaComponent;
  @ViewChildren(MaquinasMaestroModalAddEditComponent) modalesAddEditMaquina: QueryList<MaquinasMaestroModalAddEditComponent>;
  @ViewChild(MaquinasMaestroModalVerMovimientoComponent, { static: true }) modalVerMovimiento: MaquinasMaestroModalVerMovimientoComponent;
  @ViewChild(MaquinasMaestroModalAsignarComponent, { static: true }) modalAsignar: MaquinasMaestroModalAsignarComponent;
  @ViewChild(MaquinasMaestroModalDarDeBajaComponent, { static: true }) modalDarDeBaja: MaquinasMaestroModalDarDeBajaComponent;
  @ViewChild(ModalConfirmComponent, { static: true }) modalConfirm: ModalConfirmComponent;

  formHeader: FormGroup;

  // Data & Tmp
  public rutEmpresa: number;
  public sucursalCodigo: number;
  loading: boolean = false;
  listaMaquinas: Array<any> = null;
  paginationContext: PaginationContext = new PaginationContext();
  cliente: any = null;
  currentPayload: any;

  // ** el 4 corresponde a dar de baja maquina*/
  InActButton: number = 4; // Valor que puede ser modificado para activar y desactivar maquina

  files: UploadFile[];
  uploadInput: EventEmitter<UploadInput>;
  humanizeBytes: Function;
  dragOver: boolean;

  optionsFamilia: Array<any> = [];
  optionsVendedor: Array<any> = [];
  optionsProveedor: Array<any> = [];
  optionsEstado: Array<any> = [];
  optionsRubro: Array<any> = [];
  optionsSucursal: Array<any> = [];

  //TODO: VARIABLES PARA SCROLL
  currentPayLoad: any;
  totalRegistrosPos: any;
  totalPagPos: any;
  PagPosActual: any;
  notEmptyPost = true;
  notscrolly = true;
  subscription: Subscription;
  private scrollHeight = 100;
  private PageNum = 1;
  showButton = false;
  showButtonDown: boolean;

  //PINTAR FILA
  HighlightRow: number;
  EstadoMaquina: number = 4;
  estadoItem: boolean = true;

  // Utils
  private log: any;
  SelectMaquina: any;
  EditMov: any;
  totalActivos: number = 0;
  totalInactivos: number = 0;
  placaSeleccionada: string;
  canAddClientesMasivos: boolean;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private spinner: NgxSpinnerService,
    private accesolocalstorage: SecurityService,
    private messageRendererService: MessageRendererService,
    private clog: ConsoleService,
    private toastService: ToastService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    public rutService: RutService,
    private maquinaFamiliaService: MaquinaFamiliaService,
    private vendedorService: VendedorService,
    private maquinaService: MaquinaService,
    private estadoMaquinaService: EstadoMaquinaService,
    private clienteProveedorService: ClienteProveedorService,
    private rubroService: RubroService,
    private fileDownloadService: FileDownloadService,
    private rolOperacion: RolOperacionService
  ) {
    this.log = this.clog.log('MAQUINAS');
    this.canAddClientesMasivos = false;

    this.onScrollTop();

    this.files = [];
    this.uploadInput = new EventEmitter<UploadInput>();
    this.humanizeBytes = humanizeBytes;
  }

  ClickedRow(index, detalleMaquina) {
    this.HighlightRow = index;
    this.SelectMaquina = detalleMaquina;
    console.log(this.SelectMaquina);
    this.setPlacaSeleccionada(detalleMaquina.numero_placa);
    this.EstadoMaquina = detalleMaquina.estado_maquina_codigo;
    this.estadoItem = false;
  }

  @HostListener('window:scroll')
  onWindowsScroll(): void {
    const yOffSet = window.pageYOffset;
    const scrollTop = this.document.documentElement.scrollTop;

    //* MOSTRAR U OCULTAR BOTONES DE AYUDA SCROLL
    if (this.listaMaquinas != null) {
      this.showButton = (yOffSet || scrollTop) > this.scrollHeight;
      this.showButtonDown = (yOffSet || scrollTop) >= 0;
    }
  }

  //* LA BARRA DEL SCROLL QUEDA AL INICIO AL INGRESAR A LA VISTA - SCROLL CON BOTON SUBIR
  onScrollTop(): void {
    this.document.documentElement.scrollTop = 0;
  }

  // Método para establecer la placa seleccionada
  setPlacaSeleccionada(placa: string) {
    this.placaSeleccionada = placa;
  }

  // Método para obtener la placa seleccionada
  getPlacaSeleccionada(): string {
    return this.placaSeleccionada;
  }

  //* SE PUEDE REALIZAR UN SCROLL A TRAVES DEL BOTON BAJAR
  onScrollAbajo(): void {
    this.document.documentElement.scrollBy(0, 1000);
  }

  //* AL REALIZAR EL SCROLL HACIA ABAJO SE AGREGAN LOS SIGUIENTES 100 DATOS DE LA PAGINA SGTE
  onScrollDown(e): void {
    const inputParams = _.cloneDeep(this.currentPayLoad);
    if (inputParams != undefined || inputParams != null) {
      delete inputParams.paginaActual;
      this.PageNum += 1;
      inputParams.paginaActual = this.PageNum;

      this.spinner.show();
      if (this.notscrolly && this.notEmptyPost) {
        self.document.getElementById('spinnerX').style.display = 'block';

        this.maquinaService.getMaquinaFiltro(inputParams);

        this.maquinaService.queryCliente.subscribe((data: any[]) => {
          this.PagPosActual = data[0].obtenerSegunFiltroMaquina.respuesta.paginaActual;
          this.totalPagPos = data[0].obtenerSegunFiltroMaquina.respuesta.totalPaginas;
          this.totalRegistrosPos = data[0].obtenerSegunFiltroMaquina.respuesta.totalRegistros;
          this.listaMaquinas.push(...data[0].obtenerSegunFiltroMaquina.respuesta.registros);

          // console.log("Dame los siguientes datos del paginado",this.listOfCliente)
          this.spinner.hide();
          self.document.getElementById('spinnerX').style.display = 'block';
          if (data[0].obtenerSegunFiltroMaquina.respuesta.paginaActual === data[0].obtenerSegunFiltroMaquina.respuesta.totalPaginas) {
            this.notEmptyPost = false;
            self.document.getElementById('spinnerX').style.display = 'none';
          }
          if (data[0].obtenerSegunFiltroMaquina.respuesta.registros.length < data[0].obtenerSegunFiltroMaquina.respuesta.cantidadRegistrosPorPagina) {
            self.document.getElementById('spinnerX').style.display = 'none';
            this.PagPosActual = 1;
          }
          this.notscrolly = true;
        });
      }
    }
  }

  showFiles() {
    let files = '';
    for (let i = 0; i < this.files.length; i++) {
      files += this.files[i].name;
      if (!(this.files.length - 1 === i)) {
        files += ',';
      }
    }
    return files;
  }

  startUpload(): void {
    const event: UploadInput = {
      type: 'uploadAll',
      url: 'your-path-to-backend-endpoint',
      method: 'POST',
      data: { foo: 'bar' },
    };
    this.files = [];
    this.uploadInput.emit(event);
  }

  cancelUpload(id: string): void {
    this.uploadInput.emit({ type: 'cancel', id: id });
  }

  onUploadOutput(output: UploadOutput | any): void {
    if (output.type === 'allAddedToQueue') {
    } else if (output.type === 'addedToQueue') {
      this.files.push(output.file); // add file to array when added
    } else if (output.type === 'uploading') {
      // update current data in files array for uploading file
      const index = this.files.findIndex((file) => file.id === output.file.id);
      this.files[index] = output.file;
    } else if (output.type === 'removed') {
      // remove file from array when removed
      this.files = this.files.filter((file: UploadFile) => file !== output.file);
    } else if (output.type === 'dragOver') {
      this.dragOver = true;
    } else if (output.type === 'dragOut') {
    } else if (output.type === 'drop') {
      this.dragOver = false;
    }
    this.showFiles();
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());

    this.onScrollTop();
    this.paginationContext.RecordsByPage = 20;

    this.loadFamilias();
    this.loadVendedores();
    this.loadProveedores();
    this.loadEstados();
    this.loadRubros();
    this.canCargaClienteMasivo();

    this.createForms();
    this.formChangesSubscriptions();
  }

  private loadRubros() {
    this.rubroService.obtenerRubros(this.rutEmpresa, ({ respuesta }) => {
      const { registros } = respuesta; //.registros.filter(p => p.estado);
      this.optionsRubro = registros.map((rubro) => ({ value: rubro.codigo, label: rubro.descripcion, ...rubro }));
    });
  }

  private loadFamilias() {
    this.maquinaFamiliaService.obtenerTodos(({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      const { registros } = respuesta;
      this.optionsFamilia = registros.map((p) => ({ value: p.codigo, label: p.nombre }));
    });
  }

  loadVendedores() {
    this.vendedorService.obtenerActivos(this.rutEmpresa, this.sucursalCodigo, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      const { registros } = respuesta;
      this.optionsVendedor = registros.map((vendedor) => ({ value: vendedor.codigo, label: vendedor.nombre, ...vendedor }));
    });
  }

  loadProveedores() {
    const inputParams = {
      filtro: {
        exacto: { empresa_rut: this.rutEmpresa },
      },
    };
    this.clienteProveedorService.obtenerProveedoresMaquinas(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      const { registros } = respuesta;
      this.optionsProveedor = registros.map((p) => ({ value: p.rut, label: p.nombre, ...p }));
    });
  }

  loadEstados() {
    this.estadoMaquinaService.obtenerTodos(({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      const { registros } = respuesta;
      this.optionsEstado = registros.map((p) => ({ value: p.codigo, label: p.nombre, ...p }));
    });
  }

  private createForms() {
    this.formHeader = this.fb.group({
      rutCliente: [null, []],
      nroPlaca: [null, []],
      familia: [[], [Validators.required]],
      vendedor: [[], [Validators.required]],
      proveedor: [[], [Validators.required]],
      estado: [[], [Validators.required]],
      listaRubro: [[]],
    });
  }

  formChangesSubscriptions() {
    this.formHeader
      .get('rutCliente')
      .valueChanges.pipe(filter(Boolean), debounceTime(1000))
      .subscribe((rutCliente: string) => {
        this.modalSeleccionarCliente.searchByRut(rutCliente);
      });

    this.formHeader
      .get('nroPlaca')
      .valueChanges.pipe(filter(Boolean), debounceTime(1000))
      .subscribe((nroPlaca: string) => {
        if (nroPlaca != null || nroPlaca != '') this.HighlightRow = null;
      });
  }

  openModalSeleccionarcliente() {
    this.modalSeleccionarCliente.show();
  }

  onClienteSeleccionado({ data, origen }) {
    this.cliente = data;
    this.cliente.rutFormato = this.rutService.AgregarDV(this.cliente.rut);
    this.formHeader.get('rutCliente').setValue(this.cliente.rutFormato);
  }

  onClienteNoEncontrado() {
    this.cliente = null;
  }

  DespuesAsignarbuscar(pageNumber: number) {
    this.ClickedRow(this.HighlightRow, this.SelectMaquina);
    this.buscar(pageNumber);
  }

  buscar(pageNumber: number) {
    // this.formValidatorsService.validateAllFormFields(this.formHeader)
    // if (!this.formHeader.valid)
    //   return

    this.paginationContext.CurrentPage = pageNumber;
    const self = this; // this is unused

    this.listaMaquinas = [];
    // console.log(this.formHeader.get('rutCliente').value);
    const inputParams = {
      estado: this.formHeader.get('estado').value,
      familia: this.formHeader.get('familia').value,
      vendedor: this.formHeader.get('vendedor').value,
      proveedor: this.formHeader.get('proveedor').value,
      rubro: this.formHeader.get('listaRubro').value,
      filtro: {
        exacto: {
          empresa_rut: this.rutEmpresa,
          numero_placa: this.formHeader.get('nroPlaca').value,
          cliente_proveedor_rut: this.rutService.QuitarDV(this.formHeader.get('rutCliente').value || 0),
        },
      },
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: 20,
    };
    this.currentPayLoad = _.cloneDeep(inputParams);

    this.log('inputParams', JSON.stringify(inputParams));

    const inputContador = {
      estado: this.formHeader.get('estado').value,
      familia: this.formHeader.get('familia').value,
      vendedor: this.formHeader.get('vendedor').value,
      proveedor: this.formHeader.get('proveedor').value,
      rubro: this.formHeader.get('listaRubro').value,
      filtro: {
        exacto: {
          empresa_rut: this.rutEmpresa,
          numero_placa: this.formHeader.get('nroPlaca').value,
          cliente_proveedor_rut: this.rutService.QuitarDV(this.formHeader.get('rutCliente').value || 0),
        },
      },
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1,
    };

    this.maquinaService.obtenerSegunFiltroMaquina(inputContador, ({ mensajes, respuesta }) => {
      let listAllMaquinas = [];
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      const { registros } = respuesta;

      listAllMaquinas = registros;

      let arr1 = [];
      let arr2 = [];
      listAllMaquinas.forEach((element) => {
        if (element.estado_maquina_codigo != 4) {
          arr1.push(element.estado_maquina_codigo);
        } else {
          arr2.push(element.estado_maquina_codigo);
        }
      });

      this.totalActivos = arr1.length;
      this.totalInactivos = arr2.length;
    });

    this.spinner.show();

    this.maquinaService.getMaquinaFiltro(inputParams);

    this.maquinaService.queryCliente.subscribe((data: any[]) => {
      this.PagPosActual = data[0].obtenerSegunFiltroMaquina.respuesta.paginaActual;
      this.totalPagPos = data[0].obtenerSegunFiltroMaquina.respuesta.totalPaginas;
      this.totalRegistrosPos = data[0].obtenerSegunFiltroMaquina.respuesta.totalRegistros;
      this.listaMaquinas = data[0].obtenerSegunFiltroMaquina.respuesta.registros.slice(0, 20);
      this.listaMaquinas.forEach((mov) => {
        mov.rutFormato_cliente = this.rutService.AgregarDV(mov.cliente_proveedor_rut);
        mov.rutFormato_proveedor = this.rutService.AgregarDV(mov.proveedor_rut);
      });

      this.spinner.hide();
      if (data[0].obtenerSegunFiltroMaquina.respuesta.paginaActual === data[0].obtenerSegunFiltroMaquina.respuesta.totalPaginas) {
        self.document.getElementById('spinnerX').style.display = 'none';
      }
    });
    this.notscrolly = true;
    this.notEmptyPost = true;
    this.PageNum = 1;
    this.estadoItem = true;
    this.EstadoMaquina = 4;
  }

  onPageChange(context: PaginationContext) {
    this.buscar(context.RequestedPage);
  }

  downloadExcelPdf(type: 'XLS' | 'PDF') {
    const inputParams = _.cloneDeep(this.currentPayLoad);
    delete inputParams.cantidadRegistrosPorPagina;
    delete inputParams.paginaActual;

    inputParams.filtro.exacto.retornaExcel = type === 'XLS';
    inputParams.filtro.exacto.retornaPDF = type === 'PDF';

    this.log('inputParams', JSON.stringify(inputParams));

    this.maquinaService.obtenerSegunFiltroMaquinaExcelPdf(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      if (respuesta) this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo);
    });
  }

  /********* MODAL CARGA MASIVA *********/
  showModalCargaMasiva() {
    this.modalCargaMasiva.show('MAQUINA');
  }
  /********* MODAL CARGA MASIVA *********/

  /********* MODAL VER MOVIMIENTO *********/
  showModalVerMovimiento(mov) {
    this.modalVerMovimiento.load(mov);
  }
  /********* MODAL VER MOVIMIENTO *********/

  /********* MODAL ADD-EDIT MOVIMIENTO *********/
  get modalAdd() {
    return this.modalesAddEditMaquina.filter((mod) => mod.mode === 'ADD')[0];
  }

  get modalEdit() {
    return this.modalesAddEditMaquina.filter((mod) => mod.mode === 'EDIT')[0];
  }

  showModalAddMaquina() {
    this.modalAdd.show();
  }

  showModalEditMaquina(mov) {
    // console.log("QUE ESTOY MANDANDO? ", mov)
    this.modalEdit.load(mov);
    if (mov.estado_maquina_codigo === 4) {
      this.EstadoMaquina = 4;
    }
    this.EditMov = mov;
  }

  ObtenerEstadoMaquina(Dato) {
    this.ClickedRow(this.HighlightRow, this.EditMov);
    this.EstadoMaquina = 4;
    this.InActButton = 4;
    this.estadoItem = true;
    this.EditMov = null;
  }
  /********* MODAL ADD-EDIT MOVIMIENTO *********/

  /********* MODAL VER MOVIMIENTO *********/
  showModalAsignar(mov: any) {
    this.modalAsignar.show(mov);

    this.ClickedRow(this.HighlightRow, mov);
  }
  /********* MODAL VER MOVIMIENTO *********/

  /********* MODAL DAR DE BAJA *********/
  showModalModalDarDeBaja(mov) {
    this.ClickedRow(this.HighlightRow, mov);
    this.modalDarDeBaja.show(mov);
    this.EstadoMaquina = 4;
  }

  EnableAsignAndInact() {
    this.EstadoMaquina = 1;
  }
  canCargaClienteMasivo() {
    const input: any = {
      rut_usu: this.accesolocalstorage.getRutUsuario(),
      cod_operacion: 20,
      codgo_modulo: 100,
    };
    this.canAddClientesMasivos = false;
    this.rolOperacion.operacionPermitida(input, (response: boolean) => {
      this.canAddClientesMasivos = response;
    });
  }
  /********* MODAL DAR DE BAJA *********/

  // confirmEliminar(maquina: any) {
  //   this.modalConfirm.show(() => {

  //     const _maquina = _.cloneDeep(maquina)
  //     delete _maquina.__typename

  //     // const { empresa_rut, numero_placa, tipo_dte_codigo, numero_documento, observacion, fecha_baja } = maquina
  //     const inputParams = {
  //       entidad: _maquina
  //     }

  //     this.log('inputParams', JSON.stringify(inputParams))

  //     this.maquinaService.eliminar(inputParams, ({ mensajes, respuesta }) => {
  //       const ok = respuesta !== null
  //       if (!ok) {
  //         this.messageRendererService.showErrors(mensajes)
  //         return
  //       }

  //       // const { registros } = respuesta
  //       this.toastService.success('Operación realizada')
  //       this.buscar(1);
  //     })
  //   })
  // }
}
